






















































import {focusNextElement, focusPreviousElement, PlainObject} from '@labor-digital/helferlein';
import {Component, Prop, Vue} from 'vue-property-decorator';
import VuDropdownItemAbstract from './VuDropdownItemAbstract.vue';

@Component
export default class VuDropdownItemTemplate extends Vue
{

    @Prop({type: Object, default: () => ({})})
    readonly linkComponentProps: PlainObject;

    get p(): VuDropdownItemAbstract
    {
        return this.$parent as any;
    }

    get classes(): PlainObject
    {
        return {
            'vuDropdownItem--focused': this.p.api.isItemFocused(this.p.id),
            'vuDropdownItem--disabled': this.p.disabled,
            ['vuDropdownItem--' + this.p.type]: true
        };
    }

    public onKeyUp(e: KeyboardEvent): void
    {
        if (e.code === 'ArrowDown') {
            focusNextElement(this.$refs.focusPoint as HTMLElement);
        } else if (e.code === 'ArrowUp') {
            focusPreviousElement(this.$refs.focusPoint as HTMLElement);
        }
    }

    public onKeyDown(e: KeyboardEvent): void
    {
        if (e.code === 'ArrowDown' || e.code === 'ArrowUp') {
            e.stopPropagation();
            e.preventDefault();
        }
    }

    public onClick(e: MouseEvent)
    {
        if (!this.p.disabled) {
            this.p.$emit('click');
        } else {
            e.stopPropagation();
        }
    }

}
